import { HTTP_REQUEST_METHODS } from '@js/constants/js-constants.es6.js';
import HttpClient from "@js/helpers/http-client.es6.js";

const AUTHORIZATION_HEADER = 'Authorization';

export default class LuminisHttpClient extends HttpClient {
  constructor(basePath) {
    if (!basePath) {
      // TODO: LH-3072 - Remove auth header once oauth commited
      if (drupalSettings.feature_toggle.enabled.includes('oauth_mychart')) {
        basePath = drupalSettings?.luminis?.oauthRestUrl + '/';
      } else {
        basePath = drupalSettings?.luminis?.restUrl + '/';
      }
    }
    super(basePath);
  }

  static #setAuthorizationHeader(headers) {
    // TODO: LH-3072 - Remove auth header once oauth commited
    if (!drupalSettings.feature_toggle.enabled.includes('oauth_mychart')) {
      const token = LuminisHttpClient.getLoginToken();
      if (token) {
        headers[AUTHORIZATION_HEADER] = `Bearer ${token}`;
      }
    }
  }

  async get({ relativePath, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.GET;
    LuminisHttpClient.#setAuthorizationHeader(headers);

    const options = {
      method,
      relativePath: relativePath,
      headers,
      cache
    };

    const response = await super.get(options, errorMessage, errorRedirectPage, successRedirectPage);
    return response?.result;
  }

  async postJson({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.POST;
    LuminisHttpClient.#setAuthorizationHeader(headers);
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.postJson(options, errorMessage, errorRedirectPage, successRedirectPage);
    return response?.result;
  }

  async postFormData({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.POST;
    LuminisHttpClient.#setAuthorizationHeader(headers);
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.postFormData(options, errorMessage, errorRedirectPage, successRedirectPage);
    return response?.result;
  }

  async putJson({ relativePath, body = {}, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.PUT;
    LuminisHttpClient.#setAuthorizationHeader(headers);
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    return await super.putJson(options, errorMessage, errorRedirectPage, successRedirectPage);
  }

  async putFormData({
    relativePath,
    body = {},
    headers = {},
    cache = 'no-cache',
  }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.PUT;
    LuminisHttpClient.#setAuthorizationHeader(headers);
    headers['Content-Type'] = 'application/json';

    const options = {
      method,
      relativePath: relativePath,
      body,
      headers,
      cache,
    };

    const response = await super.putFormData(options, errorMessage, errorRedirectPage, successRedirectPage);
    return response?.result;
  }

  async delete({ relativePath, headers = {}, cache = 'no-cache' }, errorMessage, errorRedirectPage, successRedirectPage) {
    const method = HTTP_REQUEST_METHODS.DELETE;
    LuminisHttpClient.#setAuthorizationHeader(headers);

    const options = {
      method,
      relativePath: relativePath,
      headers,
      cache,
    };

    const response = await super.delete(options, errorMessage, errorRedirectPage, successRedirectPage);
    return response?.result;
  }

  static getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return parts
        .pop()
        .split(';')
        .shift();
  }

  // TODO: LH-3072 - Remove auth header once oauth commited
  static getLoginToken() {
    return LuminisHttpClient.getCookieValue('myChartToken');
  }
}
